export function ImageOrderBadge({
  orderNumber,
  isSelected,
}: {
  orderNumber: number | null;
  isSelected: boolean;
}) {
  return (
    <span
      className={`absolute top-1.5 left-1.5 flex h-5 min-w-5 items-center justify-center rounded-md px-1 text-[11px] font-semibold ${
        isSelected
          ? "bg-linear-to-br from-primary-400 to-secondary-400 text-white"
          : "border border-white/80 bg-black/30 text-white"
      }`}
    >
      {orderNumber}
    </span>
  );
}
